import { Capability } from "./prompt-types";

export default function CapabilityPill({
  capability,
}: {
  capability: Capability;
}) {
  const getDisplayName = (cap: Capability) => {
    if (cap === Capability.VisualQuery) return "QUERY";
    if (cap === Capability.PointSegment) return "SEGMENT";
    return cap.toUpperCase();
  };

  return (
    <div className="flex flex-row gap-2">
      <div className="font-semibold text-xs p-1 border-1 text-muted-foreground border-muted-foreground rounded-md">
        {getDisplayName(capability)}
      </div>
    </div>
  );
}
